const initialHash = typeof window === 'undefined' ? '' : window.location.hash;
let claimed = false;
let tabArrival = null;
const isHome = hash => /^(?:#?\/(?:home)?(?:\?[^#]*)?|#?)$/.test(hash);

export function prepareHomeTabOpening(route) {
  tabArrival = route;
}

export function claimHomeTabOpening({ hash = '', chapter = '', reduced = false } = {}) {
  const requested = tabArrival;
  tabArrival = null;
  return requested === hash && isHome(hash) && !chapter && !reduced;
}

export function claimHomeOpening({ hash = '', chapter = '', restored = false, reduced = false, historyReturn = false, initial = initialHash } = {}) {
  const first = !claimed;
  claimed = true;
  return first && isHome(initial) && isHome(hash) && !chapter && !restored && !reduced && !historyReturn;
}

export const HOME_OPENING = {
  // A short pause at the space and uneven keystrokes give the name a human pace.
  letters: [140, 265, 355, 490, 600, 850, 1010, 1100, 1255, 1375],
  ask: 1650, chrome: 2330, breathe: 3880, complete: 6280,
};

export const HOME_TAB_OPENING = {
  letters: [70, 170, 245, 355, 440, 640, 765, 840, 955, 1050],
  ask: 1260, chrome: 1900, breathe: 3100, complete: 5500,
};

export function playHomeOpening(root, { onType, onAsk, onChrome, onBreathe, onFinish, mode = 'intro' }) {
  const timers = new Set();
  const removers = [];
  let finished = false;
  const later = (delay, action) => {
    const timer = setTimeout(() => { timers.delete(timer); if (!finished) action(); }, delay);
    timers.add(timer);
  };
  const listen = (target, name, action, options) => {
    target.addEventListener(name, action, options);
    removers.push(() => target.removeEventListener(name, action));
  };
  const finish = () => {
    if (finished) return;
    finished = true;
    timers.forEach(clearTimeout);
    timers.clear();
    removers.splice(0).forEach(remove => remove());
    onFinish();
  };
  if (window.scrollY > 16 || document.hidden || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    finish();
    return finish;
  }
  const timing = mode === 'tab' ? HOME_TAB_OPENING : HOME_OPENING;
  timing.letters.forEach((at, index) => later(at, () => onType(index + 1)));
  later(timing.ask, onAsk);
  later(timing.chrome, onChrome);
  later(timing.breathe, onBreathe);
  later(timing.complete, finish);
  listen(window, 'scroll', () => { if (window.scrollY > 16) finish(); }, { passive: true });
  listen(window, 'wheel', finish, { passive: true });
  listen(window, 'touchmove', finish, { passive: true });
  listen(document, 'visibilitychange', () => { if (document.hidden) finish(); });
  listen(window.matchMedia('(prefers-reduced-motion: reduce)'), 'change', finish);
  listen(root, 'pointerdown', finish, { passive: true });
  listen(document, 'keydown', finish);
  return finish;
}
